import React from 'react';
import {useParams} from 'react-router-dom';
import FormModal from "components/modals/FormModal";
import _ from "lodash";
import {Calendar} from "primereact/calendar";
import {useCreateSAMMeetingMutation, useGetSAMMeetingQuery, useUpdateSAMMeetingMutation} from "../../apis/samApi";
import {DateTime} from "luxon";
import {useUserProfileQuery} from "../../apis/authenticationApi";

const SAMMeetingModal = () => {
    const { meeting } = useParams();
    const {data: editSAMMeeting, isFetching} = useGetSAMMeetingQuery(meeting);
    const [createSAMMeeting] = useCreateSAMMeetingMutation();
    const [updateSAMMeeting] = useUpdateSAMMeetingMutation();
    const {data: userProfile} = useUserProfileQuery();
    const editOnly = userProfile?.company?.role !== "CompanyOwner";

    const handleSubmit = (data) => {
        const clonedData = _.cloneDeep(data);
        const meetingDateTime = DateTime.fromJSDate(data.meetingTimestamp);
        let scheduledStartTimestamp = DateTime.fromJSDate(data.scheduledStartTimestamp);
        let scheduledEndTimestamp = DateTime.fromJSDate(data.scheduledEndTimestamp);

        scheduledStartTimestamp = scheduledStartTimestamp.set({day: meetingDateTime.day, month: meetingDateTime.month, year: meetingDateTime.year});
        scheduledEndTimestamp = scheduledEndTimestamp.set({day: meetingDateTime.day, month: meetingDateTime.month, year: meetingDateTime.year});

        clonedData.meetingTimestamp = meetingDateTime.toMillis();
        clonedData.scheduledStartTimestamp = scheduledStartTimestamp.toMillis();
        clonedData.scheduledEndTimestamp = scheduledEndTimestamp.toMillis();

        if(!clonedData.id || clonedData.id === 'new') {
            createSAMMeeting(clonedData);
        }
        else {
            updateSAMMeeting(clonedData)
        }
    }

    if(isFetching) {
        return (<></>);
    }
    else {
        const clonedTask = _.cloneDeep(editSAMMeeting);

        clonedTask.meetingTimestamp = clonedTask.meetingTimestamp < 1000 ? new Date() : new Date(clonedTask.meetingTimestamp);
        clonedTask.scheduledStartTimestamp = clonedTask.scheduledStartTimestamp < 1000 ? new Date() : new Date(clonedTask.scheduledStartTimestamp);
        clonedTask.scheduledEndTimestamp = clonedTask.scheduledEndTimestamp < 1000 ? new Date() : new Date(clonedTask.scheduledEndTimestamp);

        return (<FormModal type="SAM Meeting" editObject={clonedTask || {name: ''}} handleSubmit={editOnly? undefined : handleSubmit}
            renderForm={(formik) =>
                (<form onSubmit={formik.handleSubmit} className="formgrid grid">
                    <div className="field col-12">
                        <span className="p-float-label">
                            <Calendar className="w-4" name="meetingTimestamp" value={formik.values?.meetingTimestamp} onChange={formik.handleChange} showIcon disabled={editOnly}/>
                            <label htmlFor="meetingTimestamp">Meeting Date</label>
                        </span>
                    </div>
                    <div className="field col-12">
                        <span className="p-float-label">
                            <Calendar className="w-4" name="scheduledStartTimestamp" value={formik.values?.scheduledStartTimestamp} onChange={formik.handleChange} timeOnly hourFormat="12" showIcon icon="pi pi-clock" disabled={editOnly} />
                            <label htmlFor="scheduledStartTimestamp">Scheduled Start Time</label>
                        </span>
                    </div>
                    <div className="field col-12">
                        <span className="p-float-label">
                            <Calendar className="w-4" name="scheduledEndTimestamp" value={formik.values?.scheduledEndTimestamp} onChange={formik.handleChange} timeOnly hourFormat="12" showIcon icon="pi pi-clock" disabled={editOnly} />
                            <label htmlFor="scheduledEndTimestamp">Scheduled End Time</label>
                        </span>
                    </div>
                </form>)
            }>
        </FormModal>)
    }
}

export default SAMMeetingModal;